import { render } from "./MessageMultimedia.vue?vue&type=template&id=383405f0"
import script from "./MessageMultimedia.vue?vue&type=script&lang=js"
export * from "./MessageMultimedia.vue?vue&type=script&lang=js"

import "./MessageMultimedia.vue?vue&type=style&index=0&id=383405f0&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__